export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.dollarflightclub.com/api/admin'
};